export interface Airport {
    iataCode: string;
}
